/* import __COLOCATED_TEMPLATE__ from './show-tags-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();